/**
 * --------------------------------------------------
 *        Dashboard Menu
 * --------------------------------------------------
 */
const dashboard = {
  name: 'Dashboard',
  url: '/dashboard',
  icon: 'icon-speedometer',
}

/**
 * --------------------------------------------------
 *        Touring Menu
 * --------------------------------------------------
 */
const touring = {
  name: 'Touring',
  icon: 'icon-map',
  children: [],
}
touring.children.push({
  name: 'Live',
  url: '/touring/live',
  icon: 'icon-globe',
})
touring.children.push(
  {
    name: 'History',
    url: '/touring/history',
    icon: 'icon-clock',
  },
  {
    name: 'Summary',
    url: '/touring/summary',
    icon: 'fa fa-print',
  },
  {
    name: 'Statistics',
    url: '/touring/report',
    icon: 'icon-note',
  }
)

/**
 * --------------------------------------------------
 *        Panic Menu
 * --------------------------------------------------
 */

const panic = {
  name: 'Panic',
  icon: 'icon-energy',
  children: [
    {
      name: 'Ongoing',
      url: '/panic/ongoing',
      icon: 'icon-target',
    },
    {
      name: 'Resolved',
      url: '/panic/resolved',
      icon: 'icon-note',
    },
  ],
}

/**
 * --------------------------------------------------
 *        Summon Menu
 * --------------------------------------------------
 */

const summon = {
  name: 'Traffic',
  icon: 'icon-wallet',
  children: [
    {
      name: 'Issued',
      url: '/traffic/issued',
      icon: 'icon-login',
    },
    {
      name: 'Verified',
      url: '/traffic/verified',
      icon: 'icon-check',
    },
  ],
}
summon.children.push({
  name: 'Archived',
  url: '/traffic/archived',
  icon: 'icon-close',
})

/**
 * --------------------------------------------------
 *        Situation Report Menu
 * --------------------------------------------------
 */
const report = {
  name: 'Sit-Rep',
  icon: 'icon-fire',
  children: [
    {
      name: 'Active',
      url: '/reports/active',
      icon: 'icon-options',
    },
    {
      name: 'Archived',
      url: '/reports/archived',
      icon: 'icon-drawer',
    },
  ],
}

/**
 * --------------------------------------------------
 *        Access Token Menu
 * --------------------------------------------------
 */
const accessToken = {
  name: 'Access Token',
  url: '/access-token',
  icon: 'fa fa-key',
  class: 'mt-auto',
}

/**
 * --------------------------------------------------
 *        Contract Menu
 * --------------------------------------------------
 */
const contract = {
  name: 'Contract',
  url: '/contract',
  icon: 'fa fa-book',
}

/**
 * --------------------------------------------------
 *        Axses Menu
 * --------------------------------------------------
 */
const axsesLink = {
  name: 'Axses',
  url: 'http://axses.utmsecurity.innates.my',
  icon: 'fa fa-external-link-square',
}
const barrierLink = {
  name: 'Barrier',
  url: 'http://barrier.utmsecurity.innates.my',
  icon: 'fa fa-external-link-square',
}
const droneLink = {
  name: 'Drones',
  url: 'http://jagadrone.utmsecurity.innates.my',
  icon: 'fa fa-external-link-square',
}

/**
 * ----------------------------------------------------------
 */

const getSidebarNavMenu = (settings) => {
  // console.log('getSidebarNavMenu.settings:', settings)
  const items = []

  items.push(dashboard)
  items.push(touring)
  items.push(panic)
  if (settings.summon) {
    items.push(summon)
  }
  items.push(report)
  if (settings.utm) {
    items.push(axsesLink)
    items.push(barrierLink)
    items.push(droneLink)
  }
  items.push(accessToken)
  items.push(contract)
  return { items }
}

export default getSidebarNavMenu
